import heroesAbi from "./abis/HunkyHeroes.json";

const abis = {
  heroes: heroesAbi.abi,
};

export default abis;
